// DS2 — 섹션 래퍼(시안 base section · section.first · section.band · hub section.first/after-tabs).
// Section: padding 32(≤760 24, ds3) · 위 1px line 전폭. first = 20/28(≤760 14/20) · 선 없음(first="hub" = 14/24, ≤760 14/20).
// Band: ds4 A 로 연회색 band 폐지 — 배경 #fff · 위 전폭 구분 띠(10/≤760 8 #EEF1F5 + 위아래 1px #E3E7ED). 클래스·API 는 호환용으로 남김.
// Section 도 같은 띠(첫 섹션·탭 바로 아래는 띠 없음). 띠만 따로 필요하면 <Divider sep/>.
import type { ReactNode } from 'react';
import './ds2.css';

export interface Ds2SectionProps {
  children: ReactNode;
  id?: string;
  ariaLabelledby?: string;
  ariaLabel?: string;
  className?: string;
  as?: 'section' | 'div';
  /** 안쪽을 .ds2-wrap(max 1160 · 좌우 20/16)으로 감싼다. */
  contained?: boolean;
  /** Section 전용 — 첫 섹션. true = 20/28(홈, ≤760 14/20) · 'hub' = 14/24(허브, ≤760 14/20). */
  first?: boolean | 'hub';
  /** Section 전용 — 밑줄 탭 바로 아래(위 선 없음). */
  afterTabs?: boolean;
  /** ds4 — 이 섹션 목록의 정렬 기준(예: 「접수일 가까운 순」). 루트에 data-sort-label 로만 붙는다(CL-SORT 게이트 키) — 보이는 라벨은 SectionHead sortLabel. */
  sortLabel?: string | null;
  /** 루트에 그대로 붙일 data-* (예: data-cl-section — CL1 게이트 키). */
  dataAttrs?: Record<`data-${string}`, string>;
}

const inner = (c: ReactNode, on?: boolean) => (on ? <div className="ds2-wrap">{c}</div> : c);

export function Section({ children, id, ariaLabelledby, ariaLabel, className, as = 'section', contained, first, afterTabs, sortLabel, dataAttrs }: Ds2SectionProps) {
  const T = as;
  const attrs: Record<string, string> = { ...(dataAttrs ?? {}) };
  if (typeof sortLabel === 'string' && sortLabel.trim()) attrs['data-sort-label'] = sortLabel.trim();
  if (first) attrs['data-first'] = first === 'hub' ? 'hub' : '';
  if (afterTabs) attrs['data-after-tabs'] = '';
  return (
    <T id={id} aria-labelledby={ariaLabelledby} aria-label={ariaLabel} className={className ? `ds2-sec ${className}` : 'ds2-sec'} data-ds2="section" {...attrs}>
      {inner(children, contained)}
    </T>
  );
}

export default function Band({ children, id, ariaLabelledby, ariaLabel, className, as = 'section', contained, first, sortLabel, dataAttrs }: Ds2SectionProps) {
  const T = as;
  const attrs: Record<string, string> = { ...(dataAttrs ?? {}) };
  if (first) attrs['data-first'] = '';
  if (typeof sortLabel === 'string' && sortLabel.trim()) attrs['data-sort-label'] = sortLabel.trim();
  return (
    <T id={id} aria-labelledby={ariaLabelledby} aria-label={ariaLabel} className={className ? `ds2-band ${className}` : 'ds2-band'} data-ds2="band" {...attrs}>
      {inner(children, contained)}
    </T>
  );
}

/** 본문 폭 래퍼(.ds2-wrap). */
export function Wrap({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={className ? `ds2-wrap ${className}` : 'ds2-wrap'}>{children}</div>;
}
